export const FEATURES = {
  onboarding: true,
  dashboard: true,
  holdings: true,
  cashflow: true,
  watchlist: true,
  discover: true,
  screener: true,
  fairValue: true,
  buyDecision: true,
  lensComparison: true,
  relationshipGraph: true,
  scenarioStudio: true,
  decisionLedger: true,
  allocationController: true,
  analytics: true,
  performance: true,
  risk: true,
  backtest: true,
  whatif: true,
  income: true,
  networth: true,
  candidates: true,
  pipeline: true,
  portfolioDoctor: true,
  researchCopilot: true,
  strategyLabs: true,
  aiEngine: true,
  council: true,
  councilOrchestrator: true,
  neoIntelligence: false,
  fundOs: false,
  aiClone: false,
  deploymentGovernor: false,
  researchPrioritizer: false,
  portfolio: true,
  businessAnatomy: true,
  thesis: true,
  neoAgents: false,
  aiStrictClone: false,
  buyGenerator: false,
  marketRegime: true,
  bankSync: false,
};

export const FEATURE_ROUTES = {
  "/macro": "marketRegime",
  "/neo-intelligence": "neoIntelligence",
  "/fund-os": "fundOs",
  "/portfolio-doctor": "portfolioDoctor",
  "/research-copilot": "researchCopilot",
  "/strategy-labs": "strategyLabs",
  "/ai-engine": "aiEngine",
  "/council-brief": "councilOrchestrator",
  "/ai-clone": "aiStrictClone",
  "/ai-compare": "aiStrictClone",
  "/ai-approval": "aiStrictClone",
  "/ai-what-changed": "aiStrictClone",
  "/ai-history": "aiStrictClone",
};

export function featureForPath(path) {
  return FEATURE_ROUTES[path] || null;
}

export function isFeatureEnabled(feature) {
  if (!feature) return true;
  return FEATURES[feature] !== false;
}

export const FEATURE_VALUE_AUDIT = [
  {
    feature: "cashflow",
    who_for: ["beginner", "intermediate", "power_user"],
    teaches_or_surfaces: "Turns salary, obligations, and reserves into a safety-first view of true excess cash.",
    value_tier: 1,
    decision: "Keep",
  },
  {
    feature: "discover",
    who_for: ["beginner", "intermediate", "power_user"],
    teaches_or_surfaces: "Compares candidates through research lenses instead of stock tips.",
    value_tier: 1,
    decision: "Keep",
  },
  {
    feature: "holdings",
    who_for: ["beginner", "intermediate", "power_user"],
    teaches_or_surfaces: "Shows portfolio structure, concentration, and holding-level research context.",
    value_tier: 1,
    decision: "Keep",
  },
  {
    feature: "fairValue",
    who_for: ["intermediate", "power_user"],
    teaches_or_surfaces: "Provides valuation anchors and scenario assumptions for research support.",
    value_tier: 1,
    decision: "Keep",
  },
  {
    feature: "relationshipGraph",
    who_for: ["intermediate", "power_user"],
    teaches_or_surfaces: "Surfaces hidden business and theme relationships that are hard to see manually.",
    value_tier: 1,
    decision: "Keep",
  },
  {
    feature: "allocationController",
    who_for: ["intermediate", "power_user"],
    teaches_or_surfaces: "Explains sleeve fit and concentration pressure without automating allocation.",
    value_tier: 1,
    decision: "Keep",
  },
  {
    feature: "neoIntelligence",
    who_for: ["power_user"],
    teaches_or_surfaces: "Potential mentor layer, but needs final safety and cost review before public use.",
    value_tier: 2,
    decision: "Polish",
  },
  {
    feature: "researchCopilot",
    who_for: ["intermediate", "power_user"],
    teaches_or_surfaces: "Useful if grounded in app data, but currently overlaps with NEO and needs wording review.",
    value_tier: 2,
    decision: "Polish",
  },
  {
    feature: "portfolioDoctor",
    who_for: ["beginner", "intermediate"],
    teaches_or_surfaces: "Potentially useful as diagnostics, but risk of advice-like framing needs review.",
    value_tier: 2,
    decision: "Polish",
  },
  {
    feature: "strategyLabs",
    who_for: ["power_user"],
    teaches_or_surfaces: "Advanced experimentation surface without a clear beginner need yet.",
    value_tier: 3,
    decision: "Disable",
  },
  {
    feature: "fundOs",
    who_for: ["power_user"],
    teaches_or_surfaces: "Internal/fund operations concept that is not ready for public education value.",
    value_tier: 3,
    decision: "Disable",
  },
  {
    feature: "aiStrictClone",
    who_for: ["power_user"],
    teaches_or_surfaces: "Clone-style AI surface risks confusing users about responsibility and advice.",
    value_tier: 3,
    decision: "Disable",
  },
];
